const getData = (state, selector) => {
  const data = state.GroupsComponent.addGroupDialog
    ? state.GroupsComponent.addGroupDialog
    : state
  return !data ? null : selector(data)
}

const isOpen = state => getData(state, data => data.opened)

export { isOpen }
